var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"jump","appear":_vm.appear},on:{"before-enter":_vm.handleEnterDelay,"leave":_vm.handleLeaveDelay,"after-enter":function($event){return _vm.$emit('after-enter', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }